const Shimmer = ({ type, count = 1 }) => {
  const shimmerBlocks = {
    input: <div className="w-full h-6 bg-gray-200 rounded"></div>,
    image: <div className="w-10 h-10 bg-gray-300 rounded-md"></div>,
    text: <div className="w-28 h-4 bg-gray-300 rounded-md"></div>,
    price: <div className="w-10 h-4 bg-gray-200 rounded"></div>,
    button: (
      <div className="w-full h-10 bg-gray-300 rounded-[20px] animate-pulse"></div>
    ),
  };

  return (
    <div className="animate-pulse space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i}>{shimmerBlocks[type]}</div>
      ))}
    </div>
  );
};
export default Shimmer;